<template>
  <div>
    <div class="row">
      <div class="col-md-6" v-for="item in final">
        <div class="card card-custom">
          <div class="card-header">
            <h3 class="card-title">
              {{item.Day}}
            </h3>
          </div>
          <div class="card-body">
            <table class="table table-sm table-bordered">
              <tr class="bg-custom">
                <th>Time</th>
                <th>Class</th>
                <th>Venue</th>
              </tr>
              <tr v-for="s in item.Classes">
                <td>{{s.Time}}</td>
                <td> {{s.CourseName}} - {{s.ClassName}}</td>
                <td>{{s.Venue}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  const axios = require('axios').default;

  export default ({

    data() {
      return {
        final: [],
        days: [],
        subject: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {

    },

    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/pageLoadTimeTable')
          .then(function (res) {
              endReq();
              vm.final = res.data.final;
              //vm.days = res.data.days;
              //vm.subject = res.data.subject;
          })
        },

        getTime(day, ID, _ClassName) {
            var data = this.lst.find(u => u.Day == day && u.CourseID == ID && u.ClassName == _ClassName);
            if (data != null) {
                return data.Time;
            }
            else {
                return " ";
            }
        },

        getVenue(day, ID, _ClassName) {
            var data = this.lst.find(u => u.Day == day && u.CourseID == ID && u.ClassName == _ClassName);
            if (data != null) {
                return data.Venue;
            }
            else {
                return " ";
            }
        },
    },
  });</script>



// WEBPACK FOOTER //
// src/components/timeTable.vue